import { chunk, flatten } from "lodash";
import { addBrInStr, toVisualThousands } from "../utils";
import { labelFont, yAxisLabelColor } from "../visualConfig";

/*
 * @Author: yangyang yyangacom@163.com
 * @Date: 2023-06-09 10:25:17
 * @LastEditors: yangyang yyangacom@163.com
 * @LastEditTime: 2023-09-17 11:45:16
 * @FilePath: /dbrank_b/src/routes/visualChart/P1/chart.js
 */
const createGrid = (list = []) => {
  const len = list.length;
  const _width = (1210 - 80) / len;
  return flatten(list.map((_, index) => {
    const _index = index * 2;
    const left = `${index * _width + 80}px`;
    const width = `${_width - 20}px`;
    return [
      {
        id: _index,
        top: 100,
        bottom: '50%',
        left,
        width,
        containLabel: false,
      },
      {
        id: _index + 1,
        top: '65%',
        bottom: 50,
        left,
        width,
        containLabel: false,
      }
    ]
  }));
};

const createXAxis = (list = []) => {
  return flatten(list.map((item, index) => {
    const _index = index * 2;

    return [
      {
        name: addBrInStr(item.name, 6),
        nameLocation: 'center',
        nameTextStyle: {
          fontWeight: 'bold',
          lineHeight: 16,
          color: '#000',
        },
        gridIndex: _index,
        type: 'category',
        axisLabel: { show: false },
        axisLine: { show: false },
        axisTick: { show: false },
        minorTick: { show: false },
        splitLine: { show: false },
      },
      {
        gridIndex: _index + 1,
        type: 'category',
        axisLabel: { show: false },
        axisLine: { show: false },
        axisTick: { show: false },
        minorTick: { show: false },
        splitLine: { show: false },
      }
    ]
  }));
}

const createYAxis = (list = []) => {
  const ddd = list.map(item => [Math.max(...item.list0), Math.max(...item.list1)]);
  const [topMax, bottomMax] = ddd.reduce((acc, curr) => {
    return [Math.max(acc[0], curr[0]), Math.max(acc[1], curr[1])]
  }, [0, 0])

  return flatten(list.map((item, index) => {
    const _index = index * 2;

    return [
      {
        type: 'value',
        gridIndex: _index,
        show: index === 0,
        max: topMax,
        axisLabel: { ...yAxisLabelColor },
        axisLine: { show: false },
        axisTick: { show: false },
        minorTick: { show: false },
        splitLine: { show: false },
      },
      {
        type: 'value',
        gridIndex: _index + 1,
        show: index === 0,
        inverse: true,
        max: bottomMax,
        axisLabel: { ...yAxisLabelColor },
        axisLine: { show: false },
        axisTick: { show: false },
        minorTick: { show: false },
        splitLine: { show: false },
      },
    ]
  }));
}

const createSeries = (list = [], label = [], color = []) => {
  return flatten(list.map((item, index) => {
   
    const _index = index * 2;

    return [
      {
        xAxisIndex: _index,
        yAxisIndex: _index,
        type: 'bar',
        label: {
          show: false,
          position: 'top',
          formatter: (ele) => toVisualThousands(ele.value),
          ...labelFont,
        },
        data: item.list0.map((ele, index) => ({
          name: label[index],
          value: ele,
          itemStyle: {
            color: color[index]
          },
        })),
      },
      {
        xAxisIndex: _index + 1,
        yAxisIndex: _index + 1,
        type: 'bar',
        label: {
          show: false,
          position: 'bottom',
          formatter: (ele) => toVisualThousands(ele.value),
          ...labelFont,
        },
        data: item.list1.map((ele, index) => ({
          name: label[index],
          value: ele,
          itemStyle: {
            color: color[index]
          }
        })),
      }
    ]
  }));
}

const createGraphic = (label = [], color = []) => {
  const size = 4;
  const groupList = chunk(label, size);
  const titleGraphic = [
    {
      type: 'group',
      left: 'center',
      top: 10,
      children: [
        {
          type: 'text',
          z: 100,
          left: 20,
          top: 'middle',
          style: {
            fill: '#333',
            overflow: 'break',
            text: '新闻媒体端曝光频次',
            fontSize: '18px',
            fontWeight: 'bold',
          }
        }
      ]
    },
    {
      type: 'group',
      left: 'center',
      bottom: 10,
      children: [
        {
          type: 'text',
          z: 100,
          left: 20,
          top: 'middle',
          style: {
            fill: '#333',
            overflow: 'break',
            text: '社交媒体端曝光频次',
            fontSize: '18px',
            fontWeight: 'bold',
          }
        }
      ]
    },
  ];
  const legendGraphic = flatten(groupList.map((ele, index) => {
    const top = index * 24;

    return ele.map((item, i) => {
      const realIndex = index * size + i;

      return {
        type: 'group',
        top: 10 + top,
        left: 800 + i * 100,
        children: [
          {
            type: 'rect',
            z: 100,
            left: 0,
            top: 'middle',
            shape: {
              width: 15,
              height: 10
            },
            style: {
              fill: color[realIndex],
            }
          },
          {
            type: 'text',
            z: 100,
            left: 20,
            top: 'middle',
            style: {
              fill: '#333',
              text: `${item}`,
              font: '14px Microsoft YaHei'
            }
          }
        ]
      }
    });
  }));

  return [ ...titleGraphic, ...legendGraphic ];
}

export default ({ label = [], list = [], color = [] }) => {
 console.log(list)
  return {
    title: {},
    tooltip: {},
    graphic: createGraphic(label, color),
    grid: createGrid(list),
    xAxis: createXAxis(list),
    yAxis: createYAxis(list),
    series: createSeries(list, label, color),
  };
}


// WEBPACK FOOTER //
// src/routes/visualChart/P7/chart.js